// src/App.js
import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import Login from './Pages/Login';
import SearchCustomerNo from './Pages/SearchCustomerNo';
import RegisterCustomer from './Pages/RegisterCustomer';
import Supervisor_Dashboard from './Pages/Supervisor/Supervisor_Dashboard';
import Supervisor_Report from './Pages/Supervisor/Supervisor_Report';
import Supervisor_Team from './Pages/Supervisor/Supervisor_Team';

import Company_Report from './Pages/Company/Company_Report';
import Company_Dashboard from './Pages/Company/Company_Dashboard';
import Company_Team from './Pages/Company/Company_Team';
import CompanyPackage from './Pages/Company/CompanyPackage';
import Reversal from './Pages/Reversal';
import Report from './Pages/Report';
import Register_Company_Emp from './Pages/Company/Register_Company_Emp';
import Dashboard from './Pages/Dashboard';
import Admin_Dashboard from './Pages/Admin/Admin_Dashboard';
import Admin_Agent_Sales_Report from './Pages/Admin/Admin_Agent_Sales_Report';
import Manager_Dashboard from './Pages/Manager/Manager_Dashboard';
import Manager_Agent_Sales_Report from './Pages/Manager/Manager_Agent_Sales_Report';
import Manager_Register from './Pages/Manager/Manager_Register';
import Manager_Team from './Pages/Manager/Manager_Team';
import Manager_Packages from './Pages/Manager/Manager_Packages';

// import AgentList from './Pages/Company/AgentList';
import Claims from './Pages/Claims';
import Sales from './Pages/Sales/Sales';
import Sales_Testing from './Pages/Sales/Sales_Testing';

import Upload from './Pages/Upload';
import Agent_AssignPkgs from './Pages/Company/Agent_AssignPkgs';
import './App.css';

// ProtectedRoute component checks for role-based access
const ProtectedRoute = ({ children, requiredRole }) => {
  const [isLoading, setIsLoading] = useState(true); // To handle loading state
  const [hasAccess, setHasAccess] = useState(false); // To track access status
  const session = JSON.parse(sessionStorage.getItem("user"));
  const navigate = useNavigate();

  useEffect(() => {
    if (session?.userRole) {
      if (requiredRole.includes(session.userRole)) {
        setHasAccess(true);
      } else {
        // Redirect if the role doesn't match
        navigate('/');
      }
    } else {
      // Redirect if no session exists
      navigate('/');
    }
  }, [session, requiredRole, navigate]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Set loading state to false once authentication is completed
    if (session !== null) {
      setIsLoading(false);
    }
  }, [session]);

  if (isLoading) {
    return <div>Loading...</div>; // You can replace this with a loading spinner or something similar
  }

  return hasAccess ? children : null;
};

function App() {
  return (
    <AuthProvider> {/* Wrap the app with AuthProvider */}
      <Routes>
        {/* Public route */}
        <Route path="/" element={<Login />} />

        {/* Protected routes */}

        {/* Routes For Admin ROle */}
        <Route path="/Admin/Admin_Dashboard" element={<ProtectedRoute requiredRole="Admin"><Admin_Dashboard /></ProtectedRoute>} />
        <Route path="/Admin/Admin_Agent_Sales_Report" element={<ProtectedRoute requiredRole="Admin"><Admin_Agent_Sales_Report /></ProtectedRoute>} />

        {/* Routes For Manager Role */}
        <Route path="/Manager/Manager_Dashboard" element={<ProtectedRoute requiredRole="Manager"><Manager_Dashboard /></ProtectedRoute>} />
        <Route path="/Manager/Manager_Agent_Sales_Report" element={<ProtectedRoute requiredRole="Manager"><Manager_Agent_Sales_Report /></ProtectedRoute>} />
        <Route path="/Manager/Manager_Register" element={<ProtectedRoute requiredRole="Manager"><Manager_Register /></ProtectedRoute>} />
        <Route path="/Manager/Manager_Team" element={<ProtectedRoute requiredRole="Manager"><Manager_Team /></ProtectedRoute>} />
        <Route path="/Manager/Manager_Packages" element={<ProtectedRoute requiredRole="Manager"><Manager_Packages /></ProtectedRoute>} />

        {/* Routes For SuperAgent ROle */}
        <Route path="/SearchCustomerNo" element={<ProtectedRoute requiredRole="SuperAgent"><SearchCustomerNo /></ProtectedRoute>} />
        <Route path="/Dashboard" element={<ProtectedRoute requiredRole="JazzCash"><Dashboard /></ProtectedRoute>} />

        {/* Routes For Agent ROle */}
        <Route path="/RegisterCustomer" element={<ProtectedRoute requiredRole="Agent"> <RegisterCustomer /> </ProtectedRoute>} />
        <Route path="/Sales/Sales" element={<ProtectedRoute requiredRole="Agent"> <Sales /> </ProtectedRoute>} />
        <Route path="/Sales/Sales_Testing" element={<ProtectedRoute requiredRole="Agent"> <Sales_Testing /> </ProtectedRoute>} />


        {/* Routes For Supervisor ROle */}
        <Route path="/Supervisor/Supervisor_Dashboard" element={<ProtectedRoute requiredRole="Supervisor"> <Supervisor_Dashboard /></ProtectedRoute>} />
        <Route path="/Supervisor/Supervisor_Report" element={<ProtectedRoute requiredRole="Supervisor"> <Supervisor_Report /></ProtectedRoute>} />
        <Route path="/Supervisor/Supervisor_Team" element={<ProtectedRoute requiredRole="Supervisor"> <Supervisor_Team /></ProtectedRoute>} />


        {/* Routes For Company ROle */}
        <Route path="/Company/Company_Dashboard" element={<ProtectedRoute requiredRole={["Company", "Admin", "Manager"]}> <Company_Dashboard /></ProtectedRoute>} />
        <Route path="/Company/Company_Report" element={<ProtectedRoute requiredRole={["Company", "Admin", "Manager"]}> <Company_Report /></ProtectedRoute>} />
        <Route path="/Company/Company_Team" element={<ProtectedRoute requiredRole={["Company", "Admin"]}> <Company_Team /></ProtectedRoute>} />
        <Route path="/Company/Register_Company_Emp" element={<ProtectedRoute requiredRole={["Company", "Admin"]}> <Register_Company_Emp /></ProtectedRoute>} />
        <Route path="/Company/CompanyPackage" element={<ProtectedRoute requiredRole={["Company", "Admin"]}> <CompanyPackage /></ProtectedRoute>} />
        <Route path="/Company/Agent_AssignPkgs" element={<ProtectedRoute requiredRole={["Company", "Admin","Supervisor"]}><Agent_AssignPkgs /> </ProtectedRoute>} />
        <Route path="/Report" element={<Report />} />
        <Route path="/Upload" element={<ProtectedRoute requiredRole="Finance"> <Upload /></ProtectedRoute>} />
        <Route path="/Claims" element={<Claims />} />

        <Route path="/Reversal" element={<ProtectedRoute requiredRole="CustomerService"> <Reversal /></ProtectedRoute>} />

        {/* Fallback route */}
        {/* <Route path="*" element={<Navigate to="/" />} /> */}

      </Routes>
    </AuthProvider>
  );
}

export default App;


